<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Nuevo pedido</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<template v-if="type">
							<template v-if="type == 'providers'">
								<div class="col-md-12">
									<h3>Proveedores</h3>
									<template v-if="providers">
										<template v-if="providers.length">
											<select v-model="provider" class="form-control">
												<option v-for="provider in providers" :value="provider">
													{{ provider.name }}
												</option>
											</select>
										</template>
									</template>
								</div>
							</template>
							<template v-if="type == 'customers'">
								<div class="col-md-12">
									<h3>Clientes</h3>
									<multiselect
										v-model="customer"
										label="name"
										track-by="id"
										open-direction="bottom"
										:options="customers"
										:multiple="false"
										:searchable="true"
										:loading="multiselect.loading"
										:internal-search="false"
										:clear-on-select="true"
										:close-on-select="true"
										:options-limit="300"
										:limit="3"
										:max-height="600"
										:show-no-results="false"
										:hide-selected="true"
										placeholder="Seleccionar clientes"
										@search-change="getCustomers">
									</multiselect>
								</div>
							</template>
						</template>
						<template v-else>
							<div class="col-md-6">
								<h3>Proveedores</h3>
								<template v-if="providers">
									<template v-if="providers.length">
										<select :disabled="customer" v-model="provider" class="form-control">
											<option :value="null">Seleccionar</option>
											<option v-for="provider in providers" :value="provider">
												{{ provider.name }}
											</option>
										</select>
									</template>
								</template>
							</div>
							<div class="col-md-6">
								<h3>Clientes</h3>
								<multiselect
									:disabled="(provider) ? true : false"
									v-model="customer"
									label="name"
									track-by="id"
									open-direction="bottom"
									:options="customers"
									:multiple="false"
									:searchable="true"
									:loading="multiselect.loading"
									:internal-search="false"
									:clear-on-select="true"
									:close-on-select="true"
									:options-limit="300"
									:limit="3"
									:max-height="600"
									:show-no-results="false"
									:hide-selected="true"
									placeholder="Seleccionar clientes"
									@search-change="getCustomers">
								</multiselect>
							</div>
						</template>
					</div>
					<hr>
					<div class="row">
						<div class="col-md-12">
							<button @click="add" class="btn btn-success btn-block">
								Añadir
							</button>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'multiselect': Multiselect,
		},
		data () {
			return {
				modal: {
					selector: 'modal-create-order'
				},
				providers: null,
				provider: null,

				customers: [],
				customer: null,

				type: null,

				multiselect: {
					loading: false,
				}
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getProviders()
			},
			open(type) {
				this.type = null
				if(type) {
					this.type = type
				}

				this.provider = null
				if(this.type == 'providers') {
					if(this.providers) {
						if(this.providers.length) {
							this.provider = this.providers[0]
						}
					}
				}

				this.customer = null
				if(this.type == 'customers') {
					if(this.customers) {
						if(this.customers.length) {
							this.customer = this.customers[0]
						}
					}
				}
				
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getProviders: function() {
				this.$http.get('admin/management/providers')
					.then(response => {
						this.providers = response.body
					})
			},
			getCustomers: function(text) {
				this.multiselect.loading = true
				this.customers = []
				this.$http.get('admin/customers?per_page=50&sort=id|desc&text=' + text)
				.then(response => {
					this.customers = response.body.data
					this.multiselect.loading = false
				}).catch(response => {
					console.log(response)
					this.multiselect.loading = false
				})
			},
			editOrContinue(response) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.close()
					that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/orders/' + response.body.data.id + '/edit')
				}).catch(swal.noop)
			},
			add() {
				var that = this

				var data = {
					currency_id: this.$platform.setting.currency_id,
					lang_id: this.$platform.setting.lang_id,
					customer_id: null,
					provider_id: null,
				}

				if(this.provider) {
					data.provider_id = this.provider.id
				} else {
					if(this.customer) {
						data.customer_id = this.customer.id
					}
				}

				if(this.provider || this.customer) {
					swal.queue([{
						title: that.$t("messages.attention"),
						text: "¿Esta seguro de generar un pedido?",
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							return new Promise(function (resolve) {
								that.$http.post('admin/management/orders', data)
								.then(response => {
									that.provider = null
									that.customer = null
									that.close()
									that.$emit('reload')
									that.editOrContinue(response)
								}).catch(function(response) {
									if(response.status == 409) {
										swal(response.body.title, response.body.text, response.body.type);
									} else {
										swal({
											title: response.statusText,
											text: response.body,
											type: "warning"
										});
									}
								})
							})
						}
					}]).catch(swal.noop)
				}

			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/orders/views/Create.vue